export default __webpack_public_path__ + "static/media/space.73fa1732.svg";